import template from './branch_funding_source.create.html';
import controller from './branch_funding_source.create.controller';
import './branch_funding_source.create.controller';

let branchFundingSourcecreateComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template,
  controller
};

export default branchFundingSourcecreateComponent;


// WEBPACK FOOTER //
// ./client/app/components/branch_funding_source/create/branch_funding_source.create.component.js